// Shared Google Maps loader config.
//
// `@react-google-maps/api` deduplicates the script tag *only* when every
// loader uses the same `id` AND the same `libraries` array reference. Mixing
// `LoadScriptNext` with `useJsApiLoader`, or passing a local `["places"]`
// array literal in different files, makes the script load twice — which
// triggers the `Element with name "gmp-..." already defined` warnings and
// the `Cannot read properties of undefined (reading 'UJ')` crash.
//
// Always import these constants instead of redeclaring them.

export const GOOGLE_MAPS_LOADER_ID = "google-maps-script";

// Frozen so accidental mutations don't break the array-identity check that
// the loader uses internally.
export const GOOGLE_LIBRARIES = Object.freeze(["places"]);

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS;
